import React from 'react';

const Offer = () => {
  return (
    <section id='offer'>
      <div className='container tc'>
        <div className='s-48'></div>
        <h3 className='title-sub'>Программа обучения</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          Курсы вайб-кодинга состоят из трех модулей:
        </h4>
        <div className='s-48'></div>
        <div className='row'>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>💼</p>
              <h3 className='title-card'>Разработка портфолио</h3>
              <ul className='c-list'>
                <li>Кейсы</li>
                <li>Подряды</li>
                <li>Клиенты</li>
              </ul>
              <a href='/' className='button pink'>
                Подробнее
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>👨‍💻</p>
              <h3 className='title-card'>Создание IT-Продукта</h3>
              <ul className='c-list'>
                <li>Генерация кода</li>
                <li>Отладка ошибок</li>
                <li>Помощь менторов</li>
              </ul>
              <a href='/' className='button pink'>
                Подробнее
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>🎬</p>
              <h3 className='title-card'>PR персонального бренда в СМИ</h3>
              <ul className='c-list'>
                <li>Пиар и Новости</li>
                <li>Социальные сети</li>
                <li>Деловые партнерства</li>
              </ul>
              <a href='/' className='button pink'>
                Подробнее
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='s-48'></div>
        </div>
      </div>
    </section>
  );
};

export { Offer };
